<template>
  <app-base-main
      :hasMagin="false"
      :no-padding="true"
      parentTable
      :table-border-top="true"
      :table-shadow="false">
    <template #filter-group>
      <app-filter-group
          @query="$gjNoticeQuery"
          @reset="$gjReset">
        <ad-campaign-select v-model="campaignIds" :marketId="marketId" :portfolioId="portfolioId" v-if="!inCampaign" adType="SD" @change="campaignSelectChange($event)"></ad-campaign-select>
        <ad-group-select ref="groupSelect" v-model="groupIds" :marketId="marketId" :campaignId="campaignId" v-if="!inGroup" adType="SD"></ad-group-select>
        <gj-select
            v-model="status"
            :options="AdNegTargetEnum.SD.statusOption"
            placeholder="状态"
        ></gj-select>
        <gj-lazy-input
            v-model="keyword"
            placeholder="品牌/ASIN"
            width="150px"
        ></gj-lazy-input>
        <template v-if="!$permission('adsSdCampaigns:addOrUpdate')" #right>
          <gj-tool-group
              log @viewLog="viewLog"
              help
              setting :table-name="tableName" :table-columns="columns"
              :helpName="helpName"
          ></gj-tool-group>
          <!-- :download="$permission('product:export')" download-url="广告导出地址" :download-params="globalParams" -->
        </template>
      </app-filter-group>
    </template>
    <template v-if="$permission('adsSdCampaigns:addOrUpdate')" #operate-group>
      <gj-button
          type="primary"
          @click="add">
        新增否定商品投放
      </gj-button>
      <gj-button
          v-if="$permission('adsSdCampaigns:delete')"
          :disabled="!selectedAllIn('state', [AdNegTargetEnum.SD.status.ENABLE, AdNegTargetEnum.SD.status.PAUSE])"
          @click="archive">
        归档
      </gj-button>
    </template>
    <template v-if="$permission('adsSdCampaigns:addOrUpdate')" #tool-group>
      <gj-tool-group
          log @viewLog="viewLog"
          help
          setting :table-name="tableName" :table-columns="columns" :sort-gjtable="$refs.gjTable"
          :helpName="helpName"
      ></gj-tool-group>
      <!-- :download="$permission('product:export')" download-url="广告导出地址" :download-params="globalParams" -->
    </template>
    <template #table>
      <gj-table
          ref="gjTable"
          adaptParent
          :name="tableName"
          :loading="loading"
          :selection="$permission('adsSdCampaigns:addOrUpdate')"
          :data="tableData"
          sortable="custom"
          :pagination="pagination"
          show-summary
          :selectable="notEqSelectable('state', AdNegTargetEnum.SD.status.ARCHIVE)"
          :columns="columns"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery">
        <template v-slot:belongGroup="{row}">
          <app-sd-ad-route-link
              :ad-group-manager="{marketId, campaign: row, group: row}">
            <gj-tooltip
                :text-line="2"
                :content="row.groupName">
              {{row.groupName | defaultShow}}
            </gj-tooltip>
          </app-sd-ad-route-link>
        </template>
        <template v-slot:belongCampaign="{row}">
          <app-sd-ad-route-link
              :ad-campaign-manager="{marketId, campaign: row}">
            <gj-tooltip
                :text-line="2"
                :content="row.campaignName">
              {{row.campaignName | defaultShow}}
            </gj-tooltip>
          </app-sd-ad-route-link>
        </template>
        <template v-slot:negTargetName="{row}">
          <template v-if="row.resolvedExpressionList && row.resolvedExpressionList.length > 0">
            <gj-tooltip
                v-for="(item, i) in row.resolvedExpressionList"
                :key="i"
                :content="`${item.type}=${item.value}`"
                :text-line="1">
              <template v-if="item.type === 'asinSameAs'">
                asinSameAs=<gj-link :href="row.asinAmazonUrl" target="_blank">{{item.value}}</gj-link>
              </template>
              <template v-else-if="item.type === 'exactProduct'">商品浏览</template>
              <template v-else-if="item.type === 'similarProduct'">类似商品浏览</template>
              <template v-else-if="isMeaningful(item.type) && isMeaningful(item.value)">
                {{item.type}}={{item.value}}
              </template>
              <template v-else>-</template>
            </gj-tooltip>
          </template>
          <template v-else>-</template>
        </template>
        <template v-slot:op="{row}">
          <gj-button
              type="text"
              @click="viewLog(row)">
            操作日志
          </gj-button>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {adFields} from "../../../common/fields";
  import {
    adBaseDataMixin, currencySymbolMixin,
    inCampaignMixin,
    inGroupMixin, initDateMixin,
    inMarketMixin,
    inPortfolioMixin,
    tableNameMixin
  } from "../../../common/mixin";
  import {isMeaningfulMixin, queryMixin, selectionMixin} from "../../../../../../minxins";
  import {AdNegTargetEnum} from "../../../common/enum";
  import AppArchiveWarningModal from "../../../common/modal/update-status/archive-warning-modal";
  import AppAddSdAdNegTarget from "../../common/modal/add/neg-target/add-ad-neg-target";
  import AppSdAdRouteLink from "../../common/components/ad-route-link";
  import AdCampaignSelect from "modules/ad/common/components/ad-campaign-select.vue"
  import AdGroupSelect from "modules/ad/common/components/ad-group-select.vue"
  import {defaultVal, isMeaningful, isMeaningless} from "../../../../../../utils/common";
  import {adStore} from "../../../common/store";
  import {getSdAdNegTargetPage, updateSdAdNegTarget} from "../../../../../../api/ad";
  import {LOG_OP_TYPE} from "../../../common/options";
  import AppAdLogModal from "../../../common/modal/log/ad-log-modal";

  export default {
    name: "app-sd-ad-neg-target",
    components: {AppSdAdRouteLink, AdCampaignSelect, AdGroupSelect},
    mixins: [
      inMarketMixin, inPortfolioMixin,
      inCampaignMixin, inGroupMixin, initDateMixin,
      tableNameMixin, selectionMixin, adBaseDataMixin,
      queryMixin, currencySymbolMixin, isMeaningfulMixin
    ],
    created() {
      this.columns = [
        adFields.negTargetName,
        {...adFields.servingStatus, field: 'option:state', options: AdNegTargetEnum.SD.statusOption},
        this.inGroup ? null : adFields.belongGroup,
        this.inCampaign ? null : adFields.belongCampaign,
        // this.inCampaign ? null : adFields.belongPortfolio,
        // {...adFields.startDate, help: null}
        adFields.op,
      ].filter(e => e !== null);
    },
    data() {
      return {
        helpName:'sdadmanager',
        campaignIds: [],
        groupIds: [],
        tableData: [],
        columns: [],
        AdNegTargetEnum: AdNegTargetEnum,
        // filter
        status: AdNegTargetEnum.SD.status.ENABLE,
        keyword: null,
        date: null
      }
    },
    methods: {
      // 广告活动下拉改变
      campaignSelectChange(e) {
        this.groupIds = []
        let afferent = {
          campaignIds: e
        }
        this.$refs.groupSelect.getOptions('SD', afferent)
      },
      marketChange(marketId) {
        if (isMeaningful(marketId)) {
          this.$gjNoticeQuery();
        }
      },
      portfolioChange(portfolioId) {
        this.$gjNoticeQuery();
      },
      campaignChange(campaignId) {
        this.$gjNoticeQuery();
      },
      groupChange(groupId) {
        this.$gjNoticeQuery();
      },
      $gjQueryInitParams() {
        return {
          campaignIds: [],
          groupIds: [],
          status: AdNegTargetEnum.SD.status.ENABLE,
          keyword: null
        };
      },
      $gjQuery() {
        if (isMeaningless(this.marketId)) {
          return;
        }
        // 构造查询参数
        const params = {
          model: {
            campaignIds: this.campaignIds,
            groupIds: this.groupIds,
            marketId: this.marketId,
            portfolioId: this.portfolioId,
            campaignId: this.campaignId,
            groupId: this.groupId,
            state: defaultVal(this.status, null),
            expressionValue: this.keyword,
          },
          ...this.queryPagination,
          ...this.querySort
        };
        this.globalParams = params;
        // 查询
        this.loading = true;
        getSdAdNegTargetPage(params)
          .then((data) => {
            if (isMeaningful(data)) {
              const tableData = this.currencySymbolMixin(data.records, adStore.SD.currencySymbol);
              tableData.forEach(e => {
                try {
                  e.resolvedExpressionList = JSON.parse(e.expression);
                } catch (e) {
                  e.resolvedExpressionList = [];
                }
              });
              this.tableData = tableData;
              this.pagination = this.getPagination(data);
            }
          })
          .complete(() => {
            this.loading = false;
          });
      },
      add() {
        const modal = this.$gjCreate(AppAddSdAdNegTarget, {
          props: {
            marketId: this.marketId,
            campaign: this.campaign,
            group: this.group
          },
          on: {
            created: () => {
              this.$gjMessage.success('创建成功');
              this.$gjResetPage();
            }
          }
        });
      },
      archive() {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "归档确认",
            content: `归档后亚马逊会
            <span style="color: red;font-weight: bold;">删除</span>这些活动，
            不能再开启，
            <span style="color: red;font-weight: bold;">此操作不可逆</span>，
            请谨慎操作！`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              updateSdAdNegTarget({
                marketId: this.marketId,
                targetIds: this.selectedRows.map(e => e.targetId),
                state: AdNegTargetEnum.SD.status.ARCHIVE
              })
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        });
      },
      viewLog(row) {
        this.$gjCreate(AppAdLogModal, {
          props: {
            marketId: this.marketId,
            groupId: this.groupId,
            name: '',
            opId: isMeaningful(row) ? row.targetId : null,
            adType: LOG_OP_TYPE.SD,
            object: LOG_OP_TYPE.SD.NEG_PRODUCT_TARGET
          }
        });
      },
    }
  }
</script>

<style scoped>

</style>
